import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';
import constants from '../constants';
import getMinFontSizeByFontSize from './get-min-font-size-by-font-size';

const { MIN_VIEWPORT_PX } = constants.common;

// Linear interpolation between the min font size (at the 320px viewport) and the
// original font size (at the 1200px viewport), evaluated at the autofill
// viewports: 1024px for max-xl and 360px for max-md.
const getResponsiveFontSize = (fontSize, breakpoint) => {
  if (breakpoint !== MOBILE_BREAKPOINT && breakpoint !== TABLET_BREAKPOINT) {
    return fontSize;
  }

  // Mobile: hard cap at 49 for large sizes.
  if (breakpoint === MOBILE_BREAKPOINT && fontSize >= 64) {
    return 49;
  }

  const viewportWidth = breakpoint === MOBILE_BREAKPOINT ? 360 : 1024;
  const interpolationFactor = (viewportWidth - MIN_VIEWPORT_PX) / 880; // 0.0455 for max-md, 0.8 for max-xl
  const minFontSize = getMinFontSizeByFontSize(fontSize);

  return Math.round(minFontSize * (1 - interpolationFactor) + fontSize * interpolationFactor);
};

export default getResponsiveFontSize;
